<div><div id="big-donut"><div class="left-eye eye"></div><div class="right-eye eye"></div><div class="mouth"></div></div></div>